export const PUBLISH_RELAYS = [
  'wss://relay.cashu.email',
  'wss://relay.damus.io',
  'wss://nos.lol',
];

export const READ_RELAYS = [
  'wss://relay.cashu.email',
  'wss://relay.damus.io',
  'wss://nos.lol',
  'wss://relay.nostr.band',
  'wss://relay.tollgate.me',
];
